var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('page-header',{attrs:{"actions":_vm.actions,"header":_vm.$t('managers.title')}}),_c('div',{staticClass:"content"},[_c('admin-table',_vm._b({ref:"table"},'admin-table',_vm.tableProps,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }